import { action, makeObservable, observable, runInAction } from 'mobx';

class ChartStore {
  isStarted = false;

  launchTime = null;

  crashedOdd = null;

  isRoundFinish = false;

  chartDimensions = {
    width: 0,
    height: 0,
  };

  isCrashed = false;

  animationStartedAt = 0;

  constructor() {
    makeObservable(this, {
      isStarted: observable,
      launchTime: observable,
      isRoundFinish: observable,
      crashedOdd: observable,
      isCrashed: observable,
      animationStartedAt: observable,
      chartDimensions: observable.deep,
      setIsStarted: action.bound,
      setLaunchTime: action.bound,
      setIsCrashed: action.bound,
      setIsRoundFinish: action.bound,
      resetChartData: action.bound,
      setChartDimensions: action.bound,
      updateAnimationStartedAt: action.bound,
    });
  }

  setIsStarted(boolean) {
    this.isStarted = boolean;
  }

  updateAnimationStartedAt(animationStartedAt) {
    this.animationStartedAt = animationStartedAt;
  }

  setLaunchTime(time) {
    this.launchTime = time;
  }

  setChartDimensions(width, height) {
    this.chartDimensions = {
      width,
      height,
    };
  }

  setIsRoundFinish(boolean) {
    if (boolean) {
      setTimeout(() => {
        runInAction(() => {
          this.isRoundFinish = boolean;
        });
      }, 150);
    } else {
      this.isRoundFinish = boolean;
    }
  }

  setIsCrashed(boolean, crashedValue) {
    this.isCrashed = boolean;
    this.crashedOdd = crashedValue;
  }

  calculateChartAnimationDelay = () => {
    if (this.isStarted && this.animationStartedAt < 0) {
      return `${this.animationStartedAt}s`;
    }
    return '0s';
  };

  resetChartData() {
    this.setIsStarted(false);
    this.setIsCrashed(false, null);
    this.setIsRoundFinish(false);
    this.setLaunchTime(null);
  }
}

export const chartStore = new ChartStore();
